import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import cookie from 'cookie'
const date = new Date()
date.setDate(date.getDate() + 1) // 1 day
// date.setTime(date.getTime() + (60 * 1000)) // 1 minute
date.toUTCString()
export default ({ store, isDev, req }) => {
  createPersistedState({
    key: 'YESDOK-NETWORK',
    storage: {
      getItem: key => (process.server && req !== undefined && req.headers.cookie !== null) ? cookie.parse(req.headers.cookie || '')[key] : Cookies.getJSON(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: date, secure: !isDev }),
      removeItem: key => Cookies.remove(key)
    }
  })(store)
}
